import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/member',
  //   component: () => import('../views/TempletIndex.vue'),
  //   meta: { requireAuth: true },
  //   children: [
  //     {
  //       path: '/login',
  //       name: 'Login',
  //       component: () => import('../views/member/Login.vue'),
  //     },
  //   ]
  // },
  {
    path: '/',
    component: () => import('../views/TempletIndex.vue'),
    meta: { requireAuth: true },
    children: [
      {
        path: '/',
        name: 'Index',
        component: () => import('../views/Index.vue'),
      },
      {
        path: '/news',
        name: 'news',
        component: () => import('../views/news/News.vue'),
      },
      {
        path: '/newsPage/:id',
        name: 'newsPage',
        component: () => import('../views/news/NewsPage.vue'),
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('../views/about/About.vue'),
      },
      {
        path: '/room/:id',
        name: 'room',
        component: () => import('../views/room/Room.vue'),
      },
      {
        path: '/equipment',
        name: 'equipment',
        component: () => import('../views/equipment/Equipment.vue'),
      },
      {
        path: '/location',
        name: 'location',
        component: () => import('../views/location/Location.vue'),
      },
      {
        path: '/locationPage/:id',
        name: 'locationPage',
        component: () => import('../views/location/LocationPage.vue'),
      },
      {
        path: '/notice',
        name: 'notice',
        component: () => import('../views/notice/Notice.vue'),
      },
      {
        path: '/sign',
        name: 'sign',
        component: () => import('../views/sign/Sign.vue'),
      },
      {
        path: '/connection',
        name: 'connection',
        component: () => import('../views/connection/Connection.vue'),
      },
      // member
      {
        path: 'member/login',
        name: 'Login',
        component: () => import('../views/member/Login.vue'),
      },
      {
        path: 'member/memberHome',
        name: 'MemberHome',
        component: () => import('../views/member/MemberHome.vue'),
      },
      {
        path: 'member/memberHome/addOtherUsers',
        name: 'AddOtherUsers',
        component: () => import('../views/member/AddOtherUsers.vue'),
      },
      {
        path: 'member/memberHome/addStoredValue',
        name: 'AddStoredValue',
        component: () => import('../views/member/AddStoredValue.vue'),
      },
      {
        path: 'member/memberHome/tenantPaymentContent',
        name: 'TenantPaymentContent',
        component: () => import('../views/member/TenantPaymentContent.vue'),
      },
      {
        path: 'member/memberHome/tenantFeedback',
        name: 'TenantFeedback',
        component: () => import('../views/member/tenantFeedback/TenantFeedback.vue'),
      },
      {
        path: 'member/memberHome/maintainList',
        name: 'MaintainList',
        component: () => import('../views/member/maintain/MaintainList.vue'),
      },
      {
        path: 'member/memberHome/maintainCreate',
        name: 'MaintainCreate',
        component: () => import('../views/member/maintain/MaintainCreate.vue'),
      },
      {
        path: 'member/memberHome/maintainContent/:id',
        name: 'MaintainContent',
        component: () => import('../views/member/maintain/MaintainContent.vue'),
      },
      {
        path: 'member/memberHome/memberMailList',
        name: 'MemberMailList',
        component: () => import('../views/member/memberMail/MemberMailList.vue'),
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound404/NotFound404.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
